import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useUser } from "../../context/UserProvider";
import { Cnt } from "../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { Cnt as PublicCnt } from "../../Cnt.ThreeDeeCrate.Public.SDK/Cnt.ThreeDeeCrate.Public.SDK";
import { AppSettings } from "../../AppSettings";
import { Image, Spinner } from 'react-bootstrap';
import './LoginButton.scss';

interface LoginButtonProps {
  onSuccess?: (tokenResponse :any) => void;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ onSuccess }) => {
  const { setUser } = useUser();
  const [loading, setLoading] = useState(false);

  const handleLoginSuccess = async (tokenResponse: any) => {
    const accessToken = tokenResponse.access_token;
    setLoading(true);
    try {
        const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
        const publicApi = new PublicCnt.ThreeDeeCrate.SDK.Api(AppSettings.PublicAPIUrl);

        const authResultNoId: Cnt.ThreeDeeCrate.SDK.AuthResponse = await publicApi.auth.ValidateGoogleLogin({
          Token: accessToken
        });

        if(authResultNoId?.Token)
        {
          localStorage.setItem("access_token", authResultNoId?.Token ?? "");
          const authResultWithNoIdAndWithSubscription: Cnt.ThreeDeeCrate.SDK.AuthResponse = await publicApi.auth.ValidateUserSubscription();

          if(authResultWithNoIdAndWithSubscription?.Token)
          {
            const authResultWithIdAndSubscription: Cnt.ThreeDeeCrate.SDK.AuthResponse = await api.auth.SynchronizeUser();
            localStorage.setItem("access_token", authResultWithIdAndSubscription?.Token ?? "");
            setUser(authResultWithIdAndSubscription?.User ?? null, authResultWithIdAndSubscription.Token);
            window.location.href = window.location.href;
          }
          else{
            localStorage.removeItem("access_token");
            setUser(null, '');
            console.error("🔴 Failed to authenticate user.");
          }
        }
        else{
            localStorage.removeItem("access_token");
            setUser(null, '');
          console.error("🔴 Failed to authenticate user.");
        }
    } catch (error) {
          localStorage.removeItem("access_token");
          setUser(null, '');
      console.error("🔴 Failed to fetch user info or sync user", error);
    } finally {
      setLoading(false);
    }
  };

  const login = useGoogleLogin({
    onSuccess: handleLoginSuccess,
    onError: () => console.error("❌ Google Login Failed"),
    flow:"implicit"
  });

  return (
    <span
      onClick={() => !loading && login()}
      className="google-login-button d-inline-flex align-items-center"
      style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}
    >
      {loading ? (
        <Spinner animation="border" size="sm" className="me-2" />
      ) : (
        <Image
          roundedCircle
          src="/google_icon.webp"
          alt="Google"
          style={{ width: '21px', height: '21px', margin: 0, padding: 0 }}
        />
      )}
      <span className="d-none d-sm-inline ms-2">{loading ? 'Signing in...' : 'Login'}</span>
    </span>
  );
};
